import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Layout from '@componentes/Layout';

export const RoutePrivate = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      autorizado() ? (
        <Layout>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={{ pathname: `${homepage}/login` }} />
      )
    }
  />
);

const autorizado = () => {
  return true;
};



// WEBPACK FOOTER //
// ./src/routes/RoutePrivate.js